// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--cIk5r";
export var siteInfo = "Footer-module--site-info--8NEIo";
export var wrapper = "Footer-module--wrapper--RlZJ5";